// extracted by mini-css-extract-plugin
export default {"slot":"ChallengeMark_slot__vISr9","image":"ChallengeMark_image__9+-Dm","fallback":"ChallengeMark_fallback__tSNN2"};